import React from 'react';
import Grid from '@mui/material/Grid';
import { tableGridLabelsMapping } from '../../Utils/helper';

function GridStructure({ gridDataList, content, tab }) {
    return (
        <Grid container columnSpacing={10}>
            {
                gridDataList?.map((item, index) => (
                    (tab !== "vahan" || index !== 3)
                        ?
                        (
                            <Grid item key={tab + index} md={4}>
                                {
                                    (tab === "vahan" || tab === "panVerification")
                                        ?
                                        item?.map((item, index) => (
                                            <GridContainer key={`${item}${index}`} item={item} content={content} />
                                        ))
                                        :
                                        (
                                            <GridContainer item={item} content={content} />
                                        )
                                }
                            </Grid>
                        )
                        : null
                ))
            }
        </Grid>
    )
}

export function GridContainer({ item, content }) {
    return (
        <Grid container sx={{ fontFamily: "inter", lineHeight: "25px" }}>
            <Grid item md={5} sx={{ fontSize: "11px", color: "#666666" }}>
                {`${tableGridLabelsMapping?.[item]}:`}
            </Grid>
            <Grid item md={7} sx={{ fontSize: "12px", fontWeight: "600", color: "#3A3A3A", textTransform: "uppercase", paddingLeft: "2rem" }}>
                {(content?.[item] === true ? "True" : content?.[item] === false ? "False" : content?.[item]) || "-"}
            </Grid>
        </Grid>
    )
}

export default GridStructure